import { render, staticRenderFns } from "./step_banking-security_epidemiological_control.vue?vue&type=template&id=0435d034&scoped=true"
import script from "./step_banking-security_epidemiological_control.vue?vue&type=script&lang=js"
export * from "./step_banking-security_epidemiological_control.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0435d034",
  null
  
)

export default component.exports